import { MenuEntry } from '@europrocurement/flexy-components';

import { ADMIN_OFFRES, REALM_ADMIN, REALM_INTERN } from '@europrocurement/l2d-keycloak';
import { DocumentTypeMenuEntries } from '@europrocurement/l2d-modules/src/modules/DocumentTypes';
import { PublisherMenuEntries } from '../pages/Fournisseurs/PublisherRouter';
import { FormalitiesMenuEntries } from '../pages/Formalities';
import { PrescripteurMenuEntries } from '../pages/Prescripteurs/PrescripteurRouter';
import { SignatureMenuEntries } from '../pages/Signature/SignatureRouter';
import { AchatsMenuEntries } from '../pages/Achats/AchatsRouter';
import { FormalityMenuEntries } from '../pages/Formalities/FormalityRouter';
import { UtilisateursMenuEntries } from '../pages/Utilisateurs/UtilisateursRouter';
import { TachesMenuEntries } from '../pages/Taches';

// La gestion des types de documents est imbriquée comme sous-menu de la
// "Gestion des Formalités" (et non placée à côté).
const FormalityMenuEntriesWithDocumentTypes: MenuEntry[] = FormalityMenuEntries.map((entry) => ({
    ...entry,
    children: [...(entry.children ?? []), ...DocumentTypeMenuEntries],
}));

const menuEntries: MenuEntry[] = [
    {
        title: 'Accueil',
        icon: 'house',
        href: '/accueil',
    },

    // Prescripteur
    ...PrescripteurMenuEntries,

    // Publisher
    ...PublisherMenuEntries,

    // Comptabilité
    ...AchatsMenuEntries,

    // Import signature menu entries
    ...SignatureMenuEntries,

    // Formalities -> Dossiers / invoices
    ...FormalitiesMenuEntries,

    {
        title: 'Mes sociétés',
        icon: 'building-user',
        role: REALM_INTERN,
        href: 'societes/',
    },

    // Taches
    ...TachesMenuEntries,

    // Administration
    {
        title: 'Administration',
        icon: 'gear',
        role: REALM_INTERN,
        children: [
            {
                title: 'Configuration des offres commerciales',
                icon: 'tag',
                href: '/admin/offres',
                role: ADMIN_OFFRES,
            },
            {
                title: 'Configuration comptabilité',
                icon: 'calculator',
                href: '/admin/configuration-comptabilite',
                role: REALM_ADMIN,
            },
            {
                title: 'Grille tarifaire',
                icon: 'table-list',
                href: '/admin/grille-tarifaire',
                role: ADMIN_OFFRES,
            },
            ...FormalityMenuEntriesWithDocumentTypes,
            ...UtilisateursMenuEntries,
        ],
    },
];

export default menuEntries;
